
import React from 'react';
import { useTranslationUtils } from '@/hooks/useTranslationUtils';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';

interface BasicInfoSectionProps {
  formValues: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
}

const BasicInfoSection: React.FC<BasicInfoSectionProps> = ({ formValues, handleInputChange }) => {
  const { t } = useTranslationUtils();

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium">{t('admin.basicInfo', 'Basic Information')}</h3>
      
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="name">{t('admin.sweepstakesName', 'Name')}<span className="text-destructive">*</span></Label>
          <Input
            id="name"
            name="name"
            placeholder={t('admin.enterName', 'Enter name')}
            value={formValues.name}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="description">{t('admin.description', 'Description')}</Label>
          <Textarea
            id="description"
            name="description"
            placeholder={t('admin.enterDescription', 'Enter description')}
            value={formValues.description}
            onChange={handleInputChange}
            rows={1}
          />
        </div>
      </div>
      
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="space-y-2">
          <Label htmlFor="start_date">{t('admin.startDate', 'Start Date')}<span className="text-destructive">*</span></Label>
          <Input
            id="start_date"
            name="start_date"
            type="date"
            value={formValues.start_date}
            onChange={handleInputChange}
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="draw_date">{t('admin.drawDate', 'Draw Date')}<span className="text-destructive">*</span></Label>
          <Input
            id="draw_date"
            name="draw_date"
            type="date"
            value={formValues.draw_date}
            onChange={handleInputChange}
            required
          />
        </div>
      </div>
    </div>
  );
};

export default BasicInfoSection;
